import { HomePage } from "../pages/HomePage";
import ConsolePage from "../pages/ConsolePage";
import GamePage from "../pages/GamePage";

export const routes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "console/:consoleId",
    element: <ConsolePage/>,
  },
  {
    path: "console/:consoleId/:gameId",
    element: <GamePage/>,
  },
];
